import React, { useState } from 'react';
import { Button, message, Space, Tooltip } from 'antd';
import { FileExcelOutlined, FilePdfOutlined } from '@ant-design/icons';
import apiClient from '../api/apiClient';

const EXPORTS = {
  companies: {
    endpoint: '/api/companies/export',
    fileStem: 'rapport-entreprises',
    description: 'Toutes les entreprises et tous leurs établissements, y compris les inactifs',
  },
  subscriptions: {
    endpoint: '/api/subscription/companies/export',
    fileStem: 'rapport-souscriptions',
    description: 'Toutes les souscriptions et les établissements rattachés',
  },
};

async function errorMessageFromResponse(error) {
  const data = error?.response?.data;
  if (data instanceof Blob) {
    try {
      const parsed = JSON.parse(await data.text());
      return parsed.message || parsed.error;
    } catch {
      return null;
    }
  }
  return data?.message || data?.error || null;
}

export default function AdminPortfolioExportButtons({ kind }) {
  const [exporting, setExporting] = useState(null);
  const config = EXPORTS[kind];
  if (!config) return null;

  const download = async (format) => {
    if (exporting) return;
    setExporting(format);
    try {
      const response = await apiClient.get(`${config.endpoint}/${format}`, {
        responseType: 'blob',
        timeout: 120000,
      });
      const fileName = `${config.fileStem}-${new Date().toISOString().slice(0, 10)}.${format}`;
      const url = URL.createObjectURL(response.data);
      const link = document.createElement('a');
      link.href = url;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.setTimeout(() => URL.revokeObjectURL(url), 1000);
      message.success(`Rapport ${format === 'pdf' ? 'PDF' : 'Excel'} téléchargé.`);
    } catch (error) {
      message.error(
        (await errorMessageFromResponse(error)) ||
        'Impossible de générer le rapport. Réessayez dans un instant.',
      );
    } finally {
      setExporting(null);
    }
  };

  return (
    <Space wrap>
      <Tooltip title={config.description}>
        <Button
          aria-label="Exporter PDF"
          icon={<FilePdfOutlined />}
          loading={exporting === 'pdf'}
          disabled={Boolean(exporting) && exporting !== 'pdf'}
          onClick={() => download('pdf')}
        >
          Exporter PDF
        </Button>
      </Tooltip>
      <Tooltip title={config.description}>
        <Button
          aria-label="Exporter Excel"
          icon={<FileExcelOutlined />}
          loading={exporting === 'xlsx'}
          disabled={Boolean(exporting) && exporting !== 'xlsx'}
          onClick={() => download('xlsx')}
        >
          Exporter Excel
        </Button>
      </Tooltip>
    </Space>
  );
}
